import React, { useState, useEffect, useRef, useContext } from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { parseISO, format, isSameDay } from 'date-fns';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import { green, grey, red, blue } from '@material-ui/core/colors';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';

import { i18n } from '../../translate/i18n';

import api from '../../services/api';
import ButtonWithSpinner from '../ButtonWithSpinner';
import MarkdownWrapper from '../MarkdownWrapper';
import { Tooltip } from '@material-ui/core';
import { AuthContext } from '../../context/Auth/AuthContext';
import { TicketsContext } from '../../context/Tickets/TicketsContext';
import TransferTicketModalCustom from '../TransferTicketModalCustom';
import toastError from '../../errors/toastError';
import { v4 as uuidv4 } from 'uuid';

import RoomIcon from '@material-ui/icons/Room';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import AndroidIcon from '@material-ui/icons/Android';
import VisibilityIcon from '@material-ui/icons/Visibility';
import TicketMessagesDialog from '../TicketMessagesDialog';
import DoneIcon from '@material-ui/icons/Done';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import contrastColor from '../../helpers/contrastColor';
import ContactTag from '../ContactTag';
import IdleIndicator from '../IdleIndicator';
import IdleStatusBadge from '../IdleStatusBadge';

const useStyles = makeStyles(theme => ({
  ticket: {
    position: 'relative',
  },

  pendingTicket: {
    cursor: 'unset',
  },
  queueTag: {
    background: '#FCFCFC',
    color: '#000',
    marginRight: 1,
    padding: 1,
    fontWeight: 'bold',
    paddingLeft: 5,
    paddingRight: 5,
    borderRadius: 3,
    fontSize: '0.8em',
    whiteSpace: 'nowrap',
  },
  noTicketsDiv: {
    display: 'flex',
    height: '100px',
    margin: 40,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  newMessagesCount: {
    position: 'absolute',
    alignSelf: 'center',
    marginRight: 8,
    marginLeft: 'auto',
    top: '10px',
    left: '20px',
    borderRadius: 0,
  },
  noTicketsText: {
    textAlign: 'center',
    color: 'rgb(104, 121, 146)',
    fontSize: '14px',
    lineHeight: '1.4',
  },
  connectionTag: {
    background: 'green',
    color: '#FFF',
    marginRight: 1,
    padding: 1,
    fontWeight: 'bold',
    paddingLeft: 5,
    paddingRight: 5,
    borderRadius: 3,
    fontSize: '0.8em',
    whiteSpace: 'nowrap',
  },
  noTicketsTitle: {
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: '600',
    margin: '0px',
  },

  contactNameWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '5px',
  },

  lastMessageTime: {
    justifySelf: 'flex-end',
    textAlign: 'right',
    position: 'relative',
    top: -21,
  },

  closedBadge: {
    alignSelf: 'center',
    justifySelf: 'flex-end',
    marginRight: 32,
    marginLeft: 'auto',
  },

  contactLastMessage: {
    paddingRight: '0%',
    marginLeft: '5px',
  },

  badgeStyle: {
    color: 'white',
    backgroundColor: green[500],
  },

  acceptButton: {
    position: 'absolute',
    right: '108px',
  },

  acceptButton: {
    position: 'absolute',
    left: '50%',
  },

  ticketQueueColor: {
    flex: 'none',
    width: '8px',
    height: '100%',
    position: 'absolute',
    top: '0%',
    left: '0%',
  },

  ticketInfo: {
    position: 'relative',
    top: -13,
  },
  secondaryContentSecond: {
    display: 'flex',
    // marginTop: 5,
    //marginLeft: "5px",
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignContent: 'flex-start',
  },
  ticketInfo1: {
    position: 'relative',
    top: 13,
    right: 0,
  },
  Radiusdot: {
    '& .MuiBadge-badge': {
      borderRadius: 2,
      position: 'inherit',
      height: 16,
      margin: 2,
      padding: 3,
    },
    '& .MuiBadge-anchorOriginTopRightRectangle': {
      transform: 'scale(1) translate(0%, -40%)',
    },
  },
}));
{
  /*PLW DESIGN INSERIDO O dentro do const handleChangeTab*/
}
const TicketListItemCustom = ({ ticket, onTicketAction, refreshKey }) => {
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [ticketUser, setTicketUser] = useState(null);
  const [ticketQueueName, setTicketQueueName] = useState(null);
  const [ticketQueueColor, setTicketQueueColor] = useState(null);
  const [tag, setTag] = useState([]);
  const [whatsAppName, setWhatsAppName] = useState(null);
  const [pipelineName, setPipelineName] = useState(null);
  const [stageName, setStageName] = useState(null);
  const [stageColor, setStageColor] = useState(null);

  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const { ticketId } = useParams();
  const isMounted = useRef(true);
  const { setCurrentTicket } = useContext(TicketsContext);
  const { user } = useContext(AuthContext);
  const { profile } = user;

  // Função para obter o deal mais recente (ID mais alto)
  const getCurrentDeal = ticketData => {
    if (!ticketData) return null;

    // Se o ticket estiver fechado, não retornar deal
    if (ticketData.status === 'closed') return null;

    // Se o ticket estiver open, retornar o último deal (mais recente)
    if (ticketData.status === 'open') {
      if (!ticketData.deals || ticketData.deals.length === 0) return null;

      // Retornar o deal com maior ID (mais recente)
      return ticketData.deals.reduce((latest, current) =>
        current.id > latest.id ? current : latest
      );
    }

    return null;
  };

  useEffect(() => {
    if (ticket.userId && ticket.user) {
      setTicketUser(ticket.user?.name?.toUpperCase());
    }
    setTicketQueueName(ticket.queue?.name?.toUpperCase());
    setTicketQueueColor(ticket.queue?.color);

    if (ticket.whatsappId && ticket.whatsapp) {
      setWhatsAppName(ticket.whatsapp.name?.toUpperCase());
    }

    setTag(ticket?.tags);

    const currentDeal = getCurrentDeal(ticket);

    // Obter nome da pipeline: do deal ou da queue
    if (currentDeal?.pipeline?.name) {
      setPipelineName(currentDeal.pipeline.name.toUpperCase());
    } else if (ticket.queue?.pipeline?.name) {
      setPipelineName(ticket.queue.pipeline.name.toUpperCase());
    } else {
      setPipelineName(null);
    }

    // Obter nome do estágio: do deal
    if (currentDeal?.stage?.name) {
      setStageName(currentDeal.stage.name.toUpperCase());
      setStageColor(currentDeal.stage.color);
    } else {
      setStageName(null);
      setStageColor(null);
    }

    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ticket?.id,
    ticket?.user?.id,
    ticket?.whatsapp?.id,
    ticket?.queue?.name,
    ticket?.queue?.color,
    ticket?.queue?.pipeline?.id,
    ticket?.queue?.pipeline?.name,
    // Usar uma string serializada dos deals abertos para detectar mudanças de estágio/pipeline
    ticket?.deals?.filter(d => d.status === 'open').map(d =>
      `${d.id}-${d.stageId || d.stage?.id}-${d.pipelineId || d.pipeline?.id}-${d.stage?.name || ''}-${d.pipeline?.name || ''}`
    ).join(',') || '',
    refreshKey,
  ]);

  {
    /*CÓDIGO NOVO SAUDAÇÃO*/
  }
  const handleCloseTicket = async id => {
    setTag(ticket?.tags);
    setLoading(true);
    try {
      await api.put(`/tickets/${id}`, {
        status: 'closed',
        userId: user?.id,
        queueId: ticket?.queue?.id,
        useIntegration: false,
        promptId: null,
        integrationId: null,
      });
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
    if (isMounted.current) {
      setLoading(false);
    }
    history.push(`/tickets/`);
  };

  const handleReopenTicket = async id => {
    setLoading(true);
    try {
      await api.put(`/tickets/${id}`, {
        status: 'open',
        userId: user?.id,
        queueId: ticket?.queue?.id,
      });
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
    if (isMounted.current) {
      setLoading(false);
    }
    history.push(`/tickets/${ticket.uuid}`);
  };

  const handleOpenTransferModal = () => {
    setTransferModalOpen(true);
  };

  const handleCloseTransferModal = () => {
    setTransferModalOpen(false);
  };

  const handleTransferSuccess = () => {
    // Notificar o componente pai para atualizar a lista de tickets
    if (onTicketAction) {
      onTicketAction();
    }
  };

  const handleStageChange = (updatedTicket, refreshCallback) => {
    // Executar callback de refresh se fornecido
    if (refreshCallback) {
      refreshCallback();
    }

    // Notificar o componente pai para atualizar a lista de tickets
    if (onTicketAction) {
      onTicketAction();
    }
  };

  const handleAcepptTicket = async id => {
    setLoading(true);
    try {
      await api.put(`/tickets/${id}`, {
        status: 'open',
        userId: user?.id,
      });

      let settingIndex;

      try {
        const { data } = await api.get('/settings/');

        settingIndex = data.filter(s => s.key === 'sendGreetingAccepted');
      } catch (err) {
        toastError(err);
      }

      if (settingIndex[0].value === 'enabled' && !ticket.isGroup) {
        handleSendMessage(ticket.id, ticket);
      }

      // Notificar o componente pai para atualizar a lista de tickets
      if (onTicketAction) {
        onTicketAction();
      }
    } catch (err) {
      setLoading(false);

      toastError(err);
    }
    if (isMounted.current) {
      setLoading(false);
    }

    // handleChangeTab(null, "tickets");
    // handleChangeTab(null, "open");
    history.push(`/tickets/${ticket.uuid}`);
  };

  const handleSendMessage = async (id, ticketData) => {
    // Prioridade: mensagem do modal de criação de pipeline (queue) em /crm, depois conexão e ticket
    const greetingMessage = (
      ticketData?.queue?.pipeline?.greetingMessage ??
      ticketData?.queue?.greetingMessage ??
      ticketData?.whatsapp?.greetingMessage ??
      ticketData?.greetingMessage ??
      ''
    ).trim();
    if (!greetingMessage) return;

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: '',
      body: greetingMessage,
    };
    try {
      await api.post(`/messages/${id}`, message);
    } catch (err) {
      toastError(err);
    }
  };

  const handleSelectTicket = ticket => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const renderTicketInfo = () => {
    if (ticketUser) {
      return (
        <>
          {ticket.chatbot && (
            <Tooltip title={i18n.t('ticketsListItem.tooltip.chatbot')}>
              <AndroidIcon
                fontSize='small'
                style={{ color: grey[700], marginRight: 5 }}
              />
            </Tooltip>
          )}

          {/* </span> */}
        </>
      );
    } else {
      return (
        <>
          {ticket.chatbot && (
            <Tooltip title={i18n.t('ticketsListItem.tooltip.chatbot')}>
              <AndroidIcon
                fontSize='small'
                style={{ color: grey[700], marginRight: 5 }}
              />
            </Tooltip>
          )}
        </>
      );
    }
  };

  return (
    <React.Fragment key={ticket.id}>
      <TicketMessagesDialog
        open={openTicketMessageDialog}
        handleClose={() => setOpenTicketMessageDialog(false)}
        ticketId={ticket.id}
        refreshKey={refreshKey || 0}
      ></TicketMessagesDialog>
      <ListItem
        dense
        button
        onClick={e => {
          if (ticket.status === 'pending') return;
          handleSelectTicket(ticket);
        }}
        selected={ticketId && +ticketId === ticket.id}
        className={clsx(classes.ticket, {
          [classes.pendingTicket]: ticket.status === 'pending',
        })}
      >
        <Tooltip
          arrow
          placement='right'
          title={
            ticket.queue?.name?.toUpperCase() ||
            i18n.t('ticketsListItem.noQueue')
          }
        >
          <span
            style={{ backgroundColor: ticket.queue?.color || '#7C7C7C' }}
            className={classes.ticketQueueColor}
          ></span>
        </Tooltip>
        <ListItemAvatar>
          {ticket.status !== 'pending' ? (
            <Avatar
              style={{
                marginTop: '-20px',
                marginLeft: '-3px',
                width: '55px',
                height: '55px',
                borderRadius: '10%',
              }}
              src={ticket?.contact?.profilePicUrl}
            />
          ) : (
            <Avatar
              style={{
                marginTop: '-30px',
                marginLeft: '0px',
                width: '50px',
                height: '50px',
                borderRadius: '10%',
              }}
              src={ticket?.contact?.profilePicUrl}
            />
          )}
        </ListItemAvatar>
        <ListItemText
          disableTypography
          primary={
            <span className={classes.contactNameWrapper}>
              <Typography
                noWrap
                component='span'
                variant='body2'
                color='textPrimary'
                style={{ marginRight: '6px' }}
              >
                {ticket.contact.name}
              </Typography>
              {ticket?.idleStatus && !ticket?.fromMe && (
                <IdleStatusBadge
                  idleStatus={ticket?.idleStatus}
                  variant='circle'
                  size='small'
                />
              )}
              {profile === 'admin' && (
                <Tooltip title={i18n.t('ticketsListItem.tooltip.peek')}>
                  <VisibilityIcon
                    onClick={() => setOpenTicketMessageDialog(true)}
                    fontSize='small'
                    style={{
                      color: blue[700],
                      cursor: 'pointer',
                      marginLeft: 10,
                      verticalAlign: 'middle',
                    }}
                  />
                </Tooltip>
              )}
              <ListItemSecondaryAction>
                <Box className={classes.ticketInfo1}>{renderTicketInfo()}</Box>
              </ListItemSecondaryAction>
            </span>
          }
          secondary={
            <span className={classes.contactNameWrapper}>
              <Typography
                className={classes.contactLastMessage}
                noWrap
                component='span'
                variant='body2'
                color='textSecondary'
              >
                {' '}
                {ticket.lastMessage.includes('data:image/png;base64') ? (
                  <MarkdownWrapper> Localização</MarkdownWrapper>
                ) : (
                  <MarkdownWrapper>{ticket.lastMessage}</MarkdownWrapper>
                )}
                <span className={classes.secondaryContentSecond}>
                  {ticket?.whatsapp?.name ? (
                    <Tooltip title={i18n.t('ticketsListItem.tooltip.connection') || 'Conexão'} arrow>
                      <span>
                        <Badge className={classes.connectionTag}>
                          {ticket?.whatsapp?.name?.toUpperCase()}
                        </Badge>
                      </span>
                    </Tooltip>
                  ) : (
                    <br></br>
                  )}
                  {ticketUser ? (
                    <Tooltip title={i18n.t('ticketsListItem.tooltip.user') || 'Usuário'} arrow>
                      <span>
                        <Badge
                          style={{ backgroundColor: '#000000' }}
                          className={classes.connectionTag}
                        >
                          {ticketUser}
                        </Badge>
                      </span>
                    </Tooltip>
                  ) : (
                    <br></br>
                  )}
                  {pipelineName ? (
                    <Tooltip title={i18n.t('ticketsListItem.tooltip.pipeline') || 'Pipeline'} arrow>
                      <span>
                        <Badge className={classes.connectionTag}>
                          {pipelineName}
                        </Badge>
                      </span>
                    </Tooltip>
                  ) : (
                    <br></br>
                  )}
                  {stageName ? (
                    <Tooltip title={i18n.t('ticketsListItem.tooltip.stage') || 'Estágio'} arrow>
                      <span>
                        <Badge style={{ backgroundColor: stageColor }} className={classes.connectionTag}>
                          {stageName}
                        </Badge>
                      </span>
                    </Tooltip>
                  ) : (
                    <br></br>
                  )}
                  {/* <Badge
                    style={{
                      backgroundColor: ticket.queue?.color || '#7c7c7c',
                    }}
                    className={classes.connectionTag}
                  >
                    {ticket.queue?.name?.toUpperCase() ||
                      i18n.t('ticketsListItem.noQueue')}
                  </Badge> */}
                </span>
                {/* <span
                  style={{ paddingTop: '2px' }}
                  className={classes.secondaryContentSecond}
                >
                  {tag?.map(tag => {
                    return (
                      <ContactTag
                        tag={tag}
                        key={`ticket-contact-tag-${ticket.id}-${tag.id}`}
                      />
                    );
                  })}
                </span> */}
                <IdleIndicator ticket={ticket} />
              </Typography>

              <Badge
                className={classes.newMessagesCount}
                badgeContent={ticket.unreadMessages}
                classes={{
                  badge: classes.badgeStyle,
                }}
              />
            </span>
          }
        />
        {/* <ListItemSecondaryAction>
          {ticket.lastMessage && (
            <>
              <Typography
                className={classes.lastMessageTime}
                component='span'
                variant='body2'
                color='textSecondary'
              >
                {isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
                  <>{format(parseISO(ticket.updatedAt), 'HH:mm')}</>
                ) : (
                  <>{format(parseISO(ticket.updatedAt), 'dd/MM/yyyy')}</>
                )}
              </Typography>

              <br />
            </>
          )}
        </ListItemSecondaryAction> */}
        <span className={classes.secondaryContentSecond}>
          {ticket.status === 'pending' &&
            ticket.queue?.name?.toLowerCase() !== 'sem fila' && (
              <ButtonWithSpinner
                //color="primary"
                style={{
                  backgroundColor: 'green',
                  color: 'white',
                  padding: '0px',
                  bottom: '17px',
                  borderRadius: '0px',
                  left: '8px',
                  fontSize: '0.6rem',
                }}
                variant='contained'
                className={classes.acceptButton}
                size='small'
                loading={loading}
                //PLW DESIGN INSERIDO O handleChangeTab
                onClick={e => handleAcepptTicket(ticket.id)}
              >
                {i18n.t('ticketsList.buttons.accept')}
              </ButtonWithSpinner>
            )}
          {ticket.status !== 'closed' &&
            ticket.queue?.name?.toLowerCase() === 'sem fila' && (
              <ButtonWithSpinner
                //color="primary"
                style={{
                  backgroundColor: 'grey',
                  color: 'white',
                  padding: '0px',
                  bottom: '17px',
                  borderRadius: '0px',
                  left: '8px',
                  fontSize: '0.6rem',
                }}
                variant='contained'
                className={classes.acceptButton}
                size='small'
                loading={loading}
                onClick={handleOpenTransferModal}
              >
                {i18n.t('ticketsList.buttons.transfer')}
              </ButtonWithSpinner>
            )}
          {/* {ticket.status === 'closed' && (
            <ButtonWithSpinner
              //color="primary"
              style={{
                backgroundColor: 'red',
                color: 'white',
                padding: '0px',
                bottom: '0px',
                borderRadius: '0px',
                left: '8px',
                fontSize: '0.6rem',
              }}
              variant='contained'
              className={classes.acceptButton}
              size='small'
              loading={loading}
              onClick={e => handleReopenTicket(ticket.id)}
            >
              {i18n.t('ticketsList.buttons.reopen')}
            </ButtonWithSpinner>
          )} */}
        </span>
      </ListItem>

      <Divider variant='inset' component='li' />

      {/* Modal de Transferência para tickets da fila Sem Fila */}
      <TransferTicketModalCustom
        modalOpen={transferModalOpen}
        onClose={handleCloseTransferModal}
        ticketid={ticket.id}
        onTransferSuccess={handleTransferSuccess}
      />
    </React.Fragment>
  );
};

export default TicketListItemCustom;
